<template>
    <div>
        <b-badge
            :variant="$store.getters['answer/status2variant'](model.status)"
            >
            {{
            trans.labels[
            'form_answers.status.' + model.status
            ]
            }}
        </b-badge>
        <b-badge
            variant="danger"
            v-if="[ 'paid', 'canceling' ].indexOf(model.status) >= 0"
            >
            要対応
        </b-badge>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {
    },
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
    },
    data() {
        return {}
    },
    computed: {
        ...mapGetters([
            'trans',
        ])
    },
    async mounted() {},
    methods: {
    },
}
</script>

<style lang="scss" scoped></style>

